// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import _ from 'underscore';

myw.MapViewStackPlugin = myw.Plugin.extend({
    /**
     * @class Provides previous map views functionality <br/>
     * Adds two buttons to the toolbar that give the user the ability to cycle through previous map views
     * @param  {Application} owner                       The application
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner) {
        myw.Plugin.prototype.initialize.call(this, owner);

        this.map = this.app.map;

        this._ourEvent = false; //true if self is causing the map to generate an event

        //stack to hold the map view information
        this.mapStack = new myw.Util.RedoStack();

        //listen  for map movement/zoom
        this.map.on('moveend', this.postPanOrZoom, this);
    },

    /**
     * Stores the current map view parameters
     * Handler for map pan or zoom
     * @private
     */
    postPanOrZoom() {
        //if the previous or next view button is pressed we don't want to update the map stack array
        if (!this._ourEvent) {
            const view = this.map.getMapViewParameters();
            if (!_.isEqual(this.mapStack.current(), view)) {
                this.mapStack.push(view);
                this.trigger('change');
            }
        }
        this._ourEvent = false;
    },

    /**
     * Changes the map to  use the previous/next view parameters
     * @param {string} direction One of "previous" or "next". Whether to go back to the previous view or the following one (once you've gone back at least once)
     */
    updateView(direction) {
        this._ourEvent = true;
        const aView = direction === 'previous' ? this.mapStack.unDo() : this.mapStack.reDo();
        this.trigger('change');

        this.map.setCurrentMapViewParameters(aView);
    }
});

//register zoom-all button
const PrevMapViewButton = myw.PluginButton.extend({
    id: 'a-map-previous',
    titleMsg: 'prev_view',
    imgSrc: 'images/toolbar/arrow_left.svg',
    render() {
        this.setActive(this.owner.mapStack.hasUnDo());
    },
    action() {
        this.app.recordFunctionalityAccess('core.toolbar.previous');
        this.owner.updateView('previous');
    }
});
const NextMapViewButton = myw.PluginButton.extend({
    id: 'a-map-next',
    titleMsg: 'next_view',
    imgSrc: 'images/toolbar/arrow_right.svg',
    render() {
        this.setActive(this.owner.mapStack.hasReDo());
    },
    action() {
        this.app.recordFunctionalityAccess('core.toolbar.next');
        this.owner.updateView('next');
    }
});
myw.MapViewStackPlugin.prototype.buttons = {
    prev: PrevMapViewButton,
    next: NextMapViewButton
};

export default myw.MapViewStackPlugin;
